import { HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToggleSwitchConfig } from 'app/modules/common-utility/components/toggle-switch/toggle-switch-config';
import { Subscription } from 'rxjs';
import { HttpClientService } from '../../Services/http-client.service';
import { SessionService } from '../../Services/session.service';
import { AppSettings } from '../../app-settings';
@Component({
  selector: 'app-stats-dashboard',
  templateUrl: './stats-dashboard.component.html',
  styleUrls: ['./stats-dashboard.component.css']
})
export class StatsDashboardComponent implements OnInit {
  paceEnabledSubscription:Subscription;
  paceEnabled:boolean=false;
  showPaceTimeView:boolean=false;
  paceCompletionMatrix:any;
  completionMatrix:any;
  courseName$ = this.sessionService.courseName;
  userInfo$ = this.sessionService.getUserInfo$;
  pagesWithoutSwitch:string[] = ['your_study_plan','free_trial','test_readiness'];
  showToggle = false;
  constructor(private activatedRoute: ActivatedRoute,private router:Router, private httpClientService: HttpClientService,  private sessionService: SessionService) {
    this.graphHover = AppSettings.cdnUrl + "assets/images/hover-time.png";
    this.paceEnabledSubscription = this.sessionService.getPaceEnabled$.subscribe((data)=>{
      if(typeof data =='boolean')
      {
        this.paceEnabled = data;
        this.showPaceTimeView = true;
        this.showCompletionMatrix();
      }
    })
  }
  public doughnutChartLabels: string[] = ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'];
  public doughnutChartData: number[] = [60];
  public doughnutChartType: string = 'doughnut';
  public color: any[] = [{ backgroundColor: ["#fc8200", "#00aeef", "#7fc000", "#fdd400"] }];
  public doughnutChartOptions = {legend: {
        display: false
    },
    tooltips: {
            enabled: false
         }, cutoutPercentage: 70 };
  @Input('pageName')
  pageName: string;
  statsData: any;
  conceptQuizPercentage: number;
  practiceQuizPercentage: number;
  inProgess: number;
  new: number;
  revision: number;
  completed: number;
  canvas: Boolean = false;
  totalTime: number = 0;
  hours: number;
  minutes: number;
  graphHover: any;
  subscription:Subscription;
  item = 1;
  courseName:string;
  conceptQuiz:string="";
  practiceQuiz:String="";
  highlightConceptQuiz:boolean = false;
  highlightPracticeQuiz:boolean = false;
  editHours = true;
  paceActivity = {}
  toggleConfig:ToggleSwitchConfig;
  // events
  /* public chartClicked(e:any):void {
     console.log(e);
   }

   public chartHovered(e:any):void {
     console.log(e);
   }
*/

  ngOnInit() {
   /* this.subscription = this.sessionService.updateDashboard$
     .subscribe(item => this.getData()
   );*/
   // this.paceEnabled = true;
   this.activatedRoute.paramMap.subscribe((params)=>{
      const config:ToggleSwitchConfig = {
       option1:{
           label:'Modules',
           isActive:true,
           value:'modules',
           action:()=>{}
       },
       option2:{
           label:'Journey',
           isActive:false,
           value:'journey',
           action:()=>{
           }
       },
       showDot:true
   }
      if(params.get('view') === 'journey'){
          config.option2.isActive = true;
          config.option1.isActive = false;
          config.option1.action = ()=> {
            this.router.navigate(['page',this.pageName])
          }
        } else {
          config.option2.isActive = false;
          config.option1.isActive = true;
          config.option2.action = ()=>{
            this.router.navigate(['journey','page',this.pageName])
          }
        }
        this.toggleConfig = config;
   })
  }
  ngOnDestroy() {
    // prevent memory leak when component is destroyed
    //this.subscription.unsubscribe();
    this.paceEnabledSubscription.unsubscribe();
  }
  
  
  ngOnChanges() {
    this.getData();
    this.canvas = true;
    this.showToggle = !this.pagesWithoutSwitch.includes(this.pageName);
  }

  getData() {
    this.totalTime = 0;
    let headers = new HttpHeaders();
    this.httpClientService.get(AppSettings.restApiUrl + '/api/dashboard/' + this.pageName, headers)
      .subscribe(
      (data) => {
        this.paceActivity['numberOfHoursPerDay'] = data.dailyStudyHours;
        this.sessionService.updateDailyStudyHours(data.dailyStudyHours);
        this.statsData = data;
        this.courseName = data.courseName;
        this.sessionService.updateCourseName(data.courseName);
        this.completionMatrix = data.completionMatrix;
        this.paceCompletionMatrix = data.paceCompletionMatrix;

        data.conceptQuizPercentage = (data.conceptQuizPercentage == null ? null : Math.round(data.conceptQuizPercentage));
        data.practiceQuizPercentage = (data.practiceQuizPercentage == null ? null : Math.round(data.practiceQuizPercentage));
        data.conceptQuizPercentage = (data.conceptQuizPercentage == null ? null : Math.round(data.conceptQuizPercentage));
        this.sessionService.shareQuizType("");
        data.noQuizAttempts = false;
        if (data.conceptQuizPercentage == null && data.practiceQuizPercentage == null) {
          data.noQuizAttempts = true;
          data.conceptQuizPercentage = 40;
          data.practiceQuizPercentage = 60;

        }

        this.highlightConceptQuiz = false;
        this.highlightPracticeQuiz = false;
        data.conceptNoAttempts = (data.conceptQuizPercentage == null && data.practiceQuizPercentage != null ? true : false);
        data.practiceNoAttempts = (data.conceptQuizPercentage != null && data.practiceQuizPercentage == null ? true : false);

        this.showCompletionMatrix();

        var counter = 0;
        for (var key in data.timeSpent) {
          if (data.timeSpent[key] == null) {
            counter = counter + 1;
          }
          data.timeSpent[key] = (data.timeSpent[key] == null ? 0 : data.timeSpent[key]);
          this.totalTime = this.totalTime + data.timeSpent[key];
          data.timeSpent[key + "hover"] = false;
        }
        if (counter == 7) {
          data.timeSpent.noAttempts = true;
          for (var key in data.timeSpent) {
            data.timeSpent[key] = Math.floor(Math.random() * 18600) + 3600;
            this.totalTime = this.totalTime + data.timeSpent[key];
          }
        }

        this.hours = Math.floor(this.totalTime / 3600);
        this.minutes = Math.floor(this.totalTime % 3600 / 60);
        this.doughnutChartData=[];
        this.doughnutChartData.push(this.new);
        this.doughnutChartData.push(this.inProgess);
        this.doughnutChartData.push(this.completed);
        this.doughnutChartData.push(this.revision);
      }
      );

      this.sessionService.courseCompletionTime$.subscribe(
        data => {
          this.paceActivity['humanEfforts'] = data;
          this.paceActivity['timeSaving'] = this.paceActivity['humanEfforts']['nonPaceHumanEfforts'] -
          this.paceActivity['humanEfforts']['paceHumanEfforts'];
        }
      );

  }

  hoursPerDay(value) {
    if (Number(value.innerText) && Number(value.innerText) !== this.paceActivity['numberOfHoursPerDay']) {
      this.paceActivity['numberOfHoursPerDay'] = Number(value.innerText);
      this.sessionService.updateDailyStudyHours(this.paceActivity['numberOfHoursPerDay']);
      this.updateDailyHours();
    }
  }

  updateDailyHours() {
    let dailyStudyHours = Number(this.paceActivity['numberOfHoursPerDay']);
    const headers = new HttpHeaders();
    this.httpClientService.post(AppSettings.restApiUrl + '/api/user/daily-study-hours/' + dailyStudyHours, {}, headers).subscribe(data =>
      console.log(data));
  }

  showCompletionMatrix()
  {
    let completionMatrix = this.paceEnabled?this.paceCompletionMatrix:this.completionMatrix;
    if(completionMatrix!=undefined)
    {
      this.inProgess = (completionMatrix.inProgess == null ? 0 : completionMatrix.inProgess.toFixed(1));
      this.new = (completionMatrix.new == null ? 0 : Math.round(completionMatrix.new));
      this.revision = (completionMatrix.revision == null ? 0 : Math.round(completionMatrix.revision));
      this.completed = (completionMatrix.completed == null ? 0 : Math.round(completionMatrix.completed));
      this.inProgess = (completionMatrix.inProgess == null ? 0 : Math.round(completionMatrix.inProgess));
    }
  }
  selectedQuiz(quizType:string)
  {
      if(quizType=="CONCEPTQUIZ")
      {
        if(!this.highlightConceptQuiz && !this.highlightPracticeQuiz)
        {
          this.showConceptQuiz();
        }
        else if(!this.highlightConceptQuiz && this.highlightPracticeQuiz)
        {
          this.highlightPracticeQuiz=false;
          this.showConceptQuiz();
        }
        else if(this.highlightConceptQuiz && !this.highlightPracticeQuiz)
        {
          this.showAllQuiz();
        }
        else if(this.highlightConceptQuiz && this.highlightPracticeQuiz)
        {
          this.highlightConceptQuiz=false;
          this.showPracticeQuiz();
        }
      }
      else
      {
        if(!this.highlightConceptQuiz && !this.highlightPracticeQuiz)
        {
          this.showPracticeQuiz();
        }
        else if(!this.highlightConceptQuiz && this.highlightPracticeQuiz)
        {
          this.showAllQuiz();
        }
        else if(this.highlightConceptQuiz && !this.highlightPracticeQuiz)
        {
          this.highlightConceptQuiz=false;
          this.showPracticeQuiz();
        }
        else if(this.highlightConceptQuiz && this.highlightPracticeQuiz)
        {
          this.highlightPracticeQuiz=false;
          this.showConceptQuiz();
        }
      }
  }
  showAllQuiz()
  {
    this.practiceQuiz="";
    this.conceptQuiz="";
    this.highlightConceptQuiz=false;
    this.highlightPracticeQuiz=false;
    this.sessionService.shareQuizType("");
  }
  showPracticeQuiz()
  {
    this.highlightPracticeQuiz = true;
    this.practiceQuiz = "PRACTICEQUIZ";
    this.sessionService.shareQuizType(this.practiceQuiz);
  }
  showConceptQuiz()
  {
    this.highlightConceptQuiz = true;
    this.conceptQuiz = "CONCEPTQUIZ";
    this.sessionService.shareQuizType(this.conceptQuiz);
  }
}
